// @flow
import { Link } from "react-router-dom";
import styled, { css } from "styled-components";
import { fontBold } from "@fdr/static-ui/Typography";
import buildColor from "@fdr/static-ui/ColorPalette";

import {
  generateTransition,
  cubic,
  linear,
  opacityIn
} from "@fdr/static-ui/Transitions";

export const Container = styled.header`
  width: 100%;
  min-width: 320px;
  min-height: ${({ $height }) => $height}px;
  background-color: ${(props) => props.backgroundColor};
  padding: 0 16px;
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  position: relative;
  align-items: center;
  ${(props) =>
    props.hasBottomBorder &&
    css`
      box-shadow: 0 1px 0 0 ${buildColor("grey", "L2")};
    `}
`;

export const LogoNavigationContainer = styled.div`
  display: flex;
  align-self: stretch;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  flex: 1 1 auto;
  min-width: 50px;
  width: 100%;

  & > div,
  a {
    animation: ${opacityIn} 0.25s ease;
  }

  & > a {
    position: relative;
    text-decoration: none;
    z-index: 1;
    transition: ${generateTransition(cubic, "transform")},
      ${generateTransition(linear, "opacity")};
  }
`;

export const LinkContainer = styled(Link)`
  display: flex;
  align-items: center;
  text-decoration: none;
  width: 100%;

  & > span {
    font-family: ${fontBold};
    ${(props) =>
      props.align === "center"
        ? css`
            width: 100%;
          `
        : css`
            margin-left: 12px;
          `}
  }

  & > svg {
    ${(props) =>
      props.align === "center" &&
      css`
        position: absolute;
      `}
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  text-decoration: none;
  font-family: ${fontBold};
  text-align: center;
  padding: 0 16px;
`;

export const LogoContainer = styled(Link)`
  display: flex;
`;
